import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { InformationCard } from 'feature/informationCard'
import { MainLayout } from 'layouts'
import { FC } from 'react'

export const ReviewSuccessfulPage: FC = () => {
  return (
    <MainLayout>
      <div className='container'>
        <InformationCard
          title='Спасибо!'
          subtitle='Ваш отзыв успешно отправлен'
          Icon={<CheckCircleOutlineIcon fontSize='large' color='primary' />}
          link='/appeals'
          linkText='Мои обращения'
        />
      </div>
    </MainLayout>
  )
}
